import type { StarjackApp } from '@starjack/core';
import type { Billing } from './billing.types';

/**
 * Returns billings filtered by app: Backoffice sees all; Admin/B2b see only
 * released billings where the lift operator is in successLiftOperatorIds.
 */
export const filterBillingsForApp = (
    billings: Billing[],
    application: StarjackApp,
    liftOperatorId: string
): Billing[] =>
    application === 'Backoffice'
        ? billings
        : billings.filter(
              (b) =>
                  !!b.releasedAt &&
                  b.successLiftOperatorIds.includes(liftOperatorId)
          );
